import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BsDropdownDirective } from "ngx-bootstrap/dropdown";
import { TableColumn, TableViewFilter } from "../../../../shared/components/table-view/table-view-component-base";




@Component({
    selector: 'app-table-dropdown-filter',
    template: `<div *ngIf="column.filter" class="btn-group" #filterDropdown="bs-dropdown"
      dropdown [placement]="visibleIndex==0?'bottom left':'bottom right'" container="body" [insideClick]="true">
    <button dropdownToggle class="d-flex flex-row text-muted" style="font-size: 10px;padding:2px;margin:0;">
      <i class="fa fa-sort-down"></i>
      <i class="fa fa-filter" [ngClass]="column.filter?.value||column.filter?.mode?.endsWith('empty')?'text-warning':''"></i>
      <i *ngIf="sortKey==column.name" [ngClass]="'fa fa-long-arrow-alt-' + (bSortAscending?'up':'down')"></i>
    </button>
    <ul *dropdownMenu style="font-size:11px;" class="p-1 dropdown-menu d-flex flex-column"
      [ngClass]="visibleIndex==0?'dropdown-menu-left':'dropdown-menu-right'">
      <li>
      <div>
        <ng-container [ngSwitch]="column.filter?.mode">
          <div *ngSwitchCase="'empty'" class="font-weight-bold bg-warning">EMPTY</div>
          <div *ngSwitchCase="'not empty'" class="font-weight-bold bg-warning">NOT EMPTY</div>
          <ng-container *ngSwitchDefault>
            <fes-table-view-filter-input *ngIf="column.filter" [filter]="column.filter" [enableModeChange]="true"
              (keyUp)="onFilterInputKeyUp($event,filterDropdown)" class="w-100">
            </fes-table-view-filter-input>
          </ng-container>
        </ng-container>
      </div>
      <div *ngIf="column.name=='pathName'" class="font-italic text-info small">
        Filter is shared on all tables
      </div>
      <div class="d-flex flex-row justify-content-end pt-1">
        <button (click)="clearFieldFilter(column.name,filterDropdown)">Clear</button>
        &nbsp;
        <button (click)="filterDropdown.hide();closed.next()">OK</button>
      </div>
      </li>
    </ul>
    </div>`,
    styleUrls: [
      '../../../../shared/components/table-view/scss/table-view.scss',
      './scout-data-table.scss'
    ]
  })
  export class TableDropdownFilterComponent {

    @Input() column: TableColumn;
    @Input() sortKey: string;
    @Input() bSortAscending: boolean;
    @Input() visibleIndex: number;
    @Input() dropdownMenuClass = 'dropdown-menu-right'
    @Input() showFilterMode = false
    @Output('closed') closed = new EventEmitter<void>()

    clearFieldFilter(fieldName:string, filterDropdown: BsDropdownDirective) {
      const filter = this.column.filter
      if ( filter ) {
        filter.value='';
        if ( ['empty','not empty'].includes(filter.mode) ) {
          filter.mode = 'contains'
        }
      }
      filterDropdown.hide();
      this.closed.next();
    }

    onFilterInputKeyUp(keyUpInfo:{event:KeyboardEvent,filter:TableViewFilter}, filterDropdown: BsDropdownDirective){
      if ( keyUpInfo.event?.key == "Enter" ){
        filterDropdown.hide();
        this.closed.next();
      }

    }
  }

